export const ROLE_PERMISSIONS = {
  admin:      ["home", "inventory", "activity", "dashboard", "barcodes", "newProduct", "manageUsers", "reports", "workOrder", "delivery", "editProduct"],
  pharmacist: ["home", "inventory", "activity", "dashboard", "barcodes", "newProduct", "workOrder", "delivery", "editProduct"],
  staff:      ["home", "workOrder", "delivery", "editProduct", "barcodes"],
  readonly:   ["inventory", "activity", "dashboard"],
};
